var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "103px",
    viewBox: "0 0 92 103",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAK-Bonenberekenaar-v8",
    transform: "translate(-90, -915)",
    stroke: "#88AB54",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(91.3494, 70.2869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0, 846.5509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,75.9361005 C0,75.9361005 3.241,77.9611005 10.937,70.2651005 C18.634,62.5681005 21.875,57.7071005 28.761,57.3021005 C35.648,56.8971005 42.129,57.7071005 48.206,56.8971005 C54.282,56.0871005 56.181,53.5301005 56.181,57.9861005 C56.181,62.4421005 49.295,65.2771005 47.269,66.0881005 C45.244,66.8981005 35.116,71.3541005 35.116,71.3541005 C35.116,71.3541005 42.408,68.5181005 49.295,68.9231005 C56.181,69.3281005 59.017,70.9491005 61.852,68.9231005 C64.688,66.8981005 71.827,62.6901005 76.841,61.6321005 C79.033,61.1691005 82.107,60.4161005 86.158,61.2271005 C90.209,62.0371005 89.803,65.6821005 86.563,68.1131005 C83.322,70.5441005 65.903,81.8861005 61.852,83.5061005 C57.801,85.1271005 55.776,86.7471005 47.269,85.5321005 C38.762,84.3171005 33.091,83.1011005 24.989,86.3421005 C16.887,89.5831005 10.001,96.4691005 9.191,100.520101",
    id: "Stroke-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6576,57.0711005 C39.6576,57.0711005 60.6816,38.1851005 77.7856,60.9911005",
    id: "Stroke-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0537,19.7125005 C54.2327,23.2595005 53.9617,27.6415005 52.5867,29.2625005 C51.2117,30.8825005 46.9317,31.8635005 42.7517,28.3165005 C39.5577,25.6065005 38.1597,20.0975005 37.6777,17.6505005 C37.5517,17.0085005 38.0497,16.4205005 38.7037,16.4415005 C41.1967,16.5185005 46.8597,17.0025005 50.0537,19.7125005 Z",
    id: "Stroke-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5188,26.9753005 C71.2178,30.3733005 66.9748,29.2443005 65.6568,27.5763005 C64.3398,25.9083005 64.2218,21.5193005 68.5228,18.1213005 C71.8088,15.5243005 77.4858,15.2383005 79.9798,15.2483005 C80.6338,15.2513005 81.1118,15.8563005 80.9628,16.4933005 C80.3958,18.9213005 78.8058,24.3783005 75.5188,26.9753005 Z",
    id: "Stroke-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8104,10.1023005 C64.5794,14.5493005 61.6644,16.0383005 60.2604,15.6493005 C58.8554,15.2603005 57.1224,12.4843005 58.3534,8.03730052 C59.2944,4.63930052 62.5124,1.48530052 63.9774,0.187300525 C64.3624,-0.153699475 64.8714,-0.0126994755 65.0254,0.477300525 C65.6144,2.34430052 66.7514,6.70430052 65.8104,10.1023005 Z",
    id: "Stroke-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8269,15.4516005 C59.8269,15.4516005 57.8019,30.0346005 58.6119,48.6686005",
    id: "Stroke-51"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvironment);
export default __webpack_public_path__ + "static/media/icon-environment.6d39215bc2b7f378e6040b5cd315e7be.svg";
export { ForwardRef as ReactComponent };